import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M10.976 8.048c-.17-.103-.384-.035-.477.153a.409.409 0 00.139.526c.419.253.659.535.659.771 0 .29-.372.738-1.416 1.129-1.031.386-2.41.598-3.881.598-1.471 0-2.85-.212-3.881-.598-1.044-.391-1.416-.84-1.416-1.129 0-.236.24-.518.66-.771a.409.409 0 00.138-.526c-.094-.188-.307-.256-.477-.153C.557 8.33 0 8.812 0 9.498c0 .526.328 1.276 1.893 1.862 1.102.413 2.56.64 4.107.64 1.546 0 3.005-.227 4.107-.64C11.672 10.774 12 10.024 12 9.498c0-.686-.557-1.167-1.024-1.45z"
        fill="#fff"
      />
      <Path
        d="M3.326 10.636C4.045 10.871 4.995 11 6 11s1.955-.13 2.674-.364C9.554 10.35 10 9.934 10 9.402s-.446-.948-1.326-1.235A6.141 6.141 0 008.041 8c-.123.245-.251.496-.386.756.25.043.485.096.698.159.647.19.884.404.933.487-.05.082-.286.297-.933.487-.613.18-1.401.283-2.231.292a1.442 1.442 0 01-.244 0c-.83-.01-1.618-.112-2.231-.292-.647-.19-.884-.405-.933-.487.049-.083.286-.297.933-.487.213-.063.448-.116.698-.16-.135-.259-.263-.51-.386-.755a6.147 6.147 0 00-.633.167C2.446 8.454 2 8.87 2 9.402c0 .532.446.947 1.326 1.234z"
        fill="#fff"
      />
      <Path
        d="M6 9a.803.803 0 00.698-.42C7.748 6.74 9 4.317 9 3.214 9 1.44 7.654 0 6 0S3 1.441 3 3.213C3 4.316 4.252 6.74 5.302 8.58c.15.262.41.419.698.419zM4.794 2.992c0-.712.541-1.291 1.206-1.291.665 0 1.206.579 1.206 1.291S6.665 4.283 6 4.283c-.665 0-1.206-.579-1.206-1.291z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
